// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentAddPage_container__2Zh2q","controlsWrapper":"PaymentAddPage_controlsWrapper__3GqNt"};